// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"548":"05f4e4e2","770":"af69441c","856":"1f986c2e"}[chunkId] + ".chunk.js");